export enum EndAppointmentErrors {
  APPOINTMENT_NOT_FOUND = 'APPOINTMENT_NOT_FOUND',
  APPOINTMENT_HAS_NO_PAYMENT = 'APPOINTMENT_HAS_NO_PAYMENT',
  BILLING_API_KEY_NOT_FOUND = 'BILLING_API_KEY_NOT_FOUND',
  INVOICE_CREATION_FAILED = 'INVOICE_CREATION_FAILED',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
}
